import React from 'react';

class LoadingIndicator extends React.Component {
    
    render () {
        let classNames = ['loading'];
        if (this.props.active) classNames.push('active');

        return <div className={ classNames.join(' ') }>
            <div className="rhombus"></div>
        </div>;
    }

}

export default LoadingIndicator;
